var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M8.602 9.568a1.028 1.028 0 001.02 1.042h3.053a.862.862 0 00.825.87h1.05a.862.862 0 00.848-.87V9.568H8.602zM15.48 4.52v2.438a.69.69 0 01-.675.697v1.043a1.725 1.725 0 001.695-1.74V4.52h-1.02zM8.182 6.958a.69.69 0 01-.682.697v1.043a1.716 1.716 0 001.695-1.74V4.52H8.182v2.438z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14.97 4.52h-1.02v2.438h1.02V4.52zm-2.542 1.395a.18.18 0 01-.173.173.173.173 0 01-.172-.173V4.52h-1.02v1.395a.173.173 0 01-.243.191.173.173 0 01-.095-.191V4.52h-1.02v1.395a1.208 1.208 0 001.193 1.215c.242 0 .478-.077.675-.217.2.14.438.216.682.217h.15a.69.69 0 01-.66.533v1.042a1.717 1.717 0 001.695-1.74V4.52h-1.012v1.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.235 7.655h-1.53v1.042h1.53V7.655z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/SaudiArabia.95586df4433538f2951216898f4cf467.svg";
export { ForwardRef as ReactComponent };